// extracted by mini-css-extract-plugin
export default {"arrow-up":"LastWeekPriceStatus_arrow-up__kNL1W","arrow-down":"LastWeekPriceStatus_arrow-down__VUr49"};